import { cn } from '@/lib/cn';

interface SegmentedProps<T extends string> {
  options: ReadonlyArray<{ value: T; label: string }>;
  value: T;
  onChange: (value: T) => void;
  className?: string;
}

/** Bordered segmented control of mono labels; the active segment sits on stripeA. */
export function Segmented<T extends string>({ options, value, onChange, className }: SegmentedProps<T>) {
  return (
    <div role="radiogroup" className={cn('flex items-center gap-[3px] rounded-md border border-line p-[3px]', className)}>
      {options.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(option.value)}
            className={cn(
              'whitespace-nowrap rounded px-[14px] py-2 font-mono text-[10px] uppercase tracking-[0.14em]',
              active ? 'bg-stripeA text-ink' : 'text-faint hover:text-ink'
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
